var map = {
	"./api.json": "fa79",
	"./atest.json": "0989",
	"./demo.json": "5ce7",
	"./development.json": "c6c3",
	"./local.json": "02ed",
	"./newtest.json": "c348",
	"./production.json": "fc46",
	"./ptest.json": "056a",
	"./remote-devel.json": "e6cc",
	"./staging.json": "f812",
	"./treasurystaging.json": "7a94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f8af";